import * as angular from 'angular';
export const translateConfig = [
    '$translateProvider',
    ($translateProvider: angular.translate.ITranslateProvider) => {
        // configure Angular.Translate
        $translateProvider
            .fallbackLanguage('en')
            .preferredLanguage('en')
            .useStaticFilesLoader({
                prefix: 'content/lang/',
                suffix: '.json'
            })
            //escape translations to prevent being hacked
            .useSanitizeValueStrategy('escape')

            //.determinePreferredLanguage() // 
            .useLocalStorage();
    }
];